(function () {
    let isBound = false;

    function initCollectionListAjax() {
        if (isBound) return;
        isBound = true;

        function getContainer() {
            return document.getElementById('ProductList');
        }

        function parseContainerFromHtml(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelector('#ProductList');
        }

        /* -----------------------------
           AJAX RENDER
        ----------------------------- */
        async function renderPage(url, push = true, scroll = false) {
            const container = getContainer();
            if (!container) return;

            const sectionId = container.dataset.sectionId;
            const sectionFetchUrl = sectionId
                ? (url.includes('?') ? `${url}&section_id=${sectionId}` : `${url}?section_id=${sectionId}`)
                : null;

            container.classList.add('loading');

            try {
                let newContent = null;

                if (sectionFetchUrl) {
                    const sectionResponse = await fetch(sectionFetchUrl, {
                        credentials: 'same-origin'
                    });
                    const sectionHtml = await sectionResponse.text();
                    newContent = parseContainerFromHtml(sectionHtml);
                }

                // Fallback for templates where section_id does not return #ProductList
                if (!newContent) {
                    const pageResponse = await fetch(url, {
                        credentials: 'same-origin'
                    });
                    const pageHtml = await pageResponse.text();
                    newContent = parseContainerFromHtml(pageHtml);
                }

                if (!newContent) return;

                container.innerHTML = newContent.innerHTML;

                if (push) {
                    history.pushState({}, '', url);
                }

                if (scroll) {
                    scrollToGrid();
                }
            } finally {
                container.classList.remove('loading');
            }
        }

        /* -----------------------------
           SCROLL TO GRID (RESIZE SAFE)
        ----------------------------- */
        function scrollToGrid() {
            const grid = document.querySelector('.product-list-main');
            const header = document.querySelector('.header');

            if (!grid) return;

            const isMobile = window.innerWidth < 767;

            let offset = 0;

            if (header) {
                const headerHeight = header.getBoundingClientRect().height;

                if (header.closest('.wrapper.no-bar')) {
                    offset = headerHeight + 40;
                } else {
                    offset = headerHeight + 70;
                }
            }

            const top = grid.getBoundingClientRect().top + window.pageYOffset - (isMobile ? offset : 50);

            window.scrollTo({
                top,
                behavior: 'smooth'
            });

        }
        /* -----------------------------
           PAGINATION CLICK
        ----------------------------- */
        document.addEventListener('click', function (e) {

            const link = e.target.closest('.paging a');
            if (!link) return;

            e.preventDefault();

            renderPage(link.href, true, true);
        });

        /* -----------------------------
           BACK / FORWARD NAVIGATION
        ----------------------------- */
        window.addEventListener('popstate', () => {
            renderPage(location.href, false);
        });
    }

    /* -----------------------------
       INIT
    ----------------------------- */
    document.addEventListener('DOMContentLoaded', initCollectionListAjax);
    document.addEventListener('shopify:section:load', initCollectionListAjax);

})();